import { EstimateDataByContractorsResponse, EstimateStatisticsRequest, EstimateStatisticsResponse } from "./types/model";
import { apiRequest } from "../client";

async function post<T>(url: string, body: unknown): Promise<T> {
  const response = await apiRequest(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json() as T;
}

export const estimatesApi = {
  GetDataByContractors: async (request: EstimateStatisticsRequest): Promise<EstimateDataByContractorsResponse> => {
    return await post<EstimateDataByContractorsResponse>("/estimate/by-contractor", request);
  },
  GetStatistics: async (request: EstimateStatisticsRequest): Promise<EstimateStatisticsResponse> => {
    return await post<EstimateStatisticsResponse>("/estimate/statistics", request);
  },
}

